import { MUITab } from "@abb/arcadia-ui-react"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../services/api"
import { BackToURL } from "../../../components/BackToURL"
import { DiMaProgress } from "../../../components/DiMaProgress"
import { UserContext } from "../../../context/UserContext"
import { GatewayManufacturedDeviceInfo } from "../../../models/Gateway"
import { useHashTab } from "../../../../hooks/useHashTab"
import { GatewaysManufacturedDeviceDetails } from "./manufacturedDevice_details_tab/GatewaysManufacturedDeviceDetails"

const returnURL = "/gateways#manufactured-devices"

export function GatewaysManufacturedDeviceContainer() {
  const { deviceId } = useParams()
  const { user, isLoadingUser } = useContext(UserContext)
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")
  const [device, setDevice] = useState<GatewayManufacturedDeviceInfo>()

  useEffect(() => {
    if (deviceId) {
      digitalManagerApi
        .get<GatewayManufacturedDeviceInfo>(`/gateway/manufacturedDevices/${deviceId}`)
        .then((res) => {
          setDevice(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [deviceId, navigate])

  if (!deviceId) {
    return <Navigate to={returnURL} />
  }

  if (!device || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  return (
    <div>
      <BackToURL url={returnURL} />

      <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
        <MUITab
          tabItems={[{ id: "details", label: "Details" }]}
          value={activeTab}
          handleChange={handleTabChange}
        />

        {activeTab === "details" && (
          <GatewaysManufacturedDeviceDetails device={device} user={user} />
        )}
      </div>
    </div>
  )
}
